<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.5 21.5">
		<path d="M1 7.75A.7502.7502 0 0 1 .25 7V1A.7502.7502 0 0 1 1 .25h6a.75.75 0 0 1 0 1.5H1.75V7a.7502.7502 0 0 1-.75.75ZM21 21.75h-6a.75.75 0 0 1 0-1.5h5.25V15a.75.75 0 0 1 1.5 0v6a.7502.7502 0 0 1-.75.75ZM21 7.75a.7502.7502 0 0 1-.75-.75V1.75H15a.75.75 0 0 1 0-1.5h6a.7502.7502 0 0 1 .75.75v6a.7502.7502 0 0 1-.75.75ZM7 21.75H1A.7502.7502 0 0 1 .25 21v-6a.75.75 0 0 1 1.5 0v5.25H7a.75.75 0 0 1 0 1.5Z" transform="translate(-.25 -.25)"/>
	</svg>
</template>
